import {internalApi} from "../../common/axios";
import {useMutationBase, useQueryBase} from "../../shared/hooks/useHookBase";

const fetchMailTitle = async () => {
    const { data } = await internalApi.get("country/mailTitle");
    return data.mailTitleData;
};

export const useMailTitle = () => {
    return useQueryBase('mailTitle', fetchMailTitle);
};

const updateMailTitle = async (mailTitle) => {
    await internalApi.post('country/mailTitle', mailTitle);
    return mailTitle;
};

export const useUpdateMailTitle = () => {
    return useMutationBase('mailTitle', updateMailTitle);
}